import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c4328d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "caron-time" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sty" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "time-title" }, "碳排放实时监测", -1))
const _hoisted_4 = {
  id: "caron-time-chart",
  class: "line-echart"
}
const _hoisted_5 = { class: "no-data" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _withDirectives(_createElementVNode("div", _hoisted_4, null, 512), [
      [_vShow, !_ctx.isEmpty]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_5, null, 512), [
      [_vShow, _ctx.isEmpty]
    ])
  ]))
}